import { useRouter } from 'next/router'
import { useEffect } from 'react'
import { Article } from '@/components/Article'
import { getStaticPaths, makeStaticProps } from '@/utils/getStatic'
import languageDetector from '@/utils/languageDetector'

const ArticlePage = () => {
  const router = useRouter()
  useEffect(() => {
    const cachedLocale = localStorage.getItem('i18nextLng')
    if (
      router.query.locale !== cachedLocale &&
      languageDetector.cache &&
      router.query.locale
    ) {
      languageDetector.cache(router.query.locale.toString())
    }
  }, [router])
  return (
    <>
      {router.query.contentId?.length && (
        <Article contentId={router.query.contentId.toString()} />
      )}
    </>
  )
}

export default ArticlePage
const getStaticProps = makeStaticProps(['common', 'articles-listing'])

export { getStaticPaths, getStaticProps }
